import { useEffect } from 'react';
import { publishUsableWorkingProject, useRefetchSharedOnFocus, useWorkingProject } from '@/api/iam';

/** Keeps the shared lists fresh on window focus, and the snapshot that the request interceptor reads (`readUsableWorkingProject`) equal to what the top bar shows. */
export function WorkingProjectSync() {
  useRefetchSharedOnFocus();
  const { project, settled } = useWorkingProject();
  useEffect(() => {
    publishUsableWorkingProject({ project, settled });
    return () => publishUsableWorkingProject({ project: null, settled: false });
  }, [project, settled]);
  return null;
}
